<div class="campanhas-page">
  
  <app-page-header title="Campanhas">
    <ng-container actions>
      <div class="actions-menu" [class.actions-menu--open]="relatoriosMenuAberto()">
        <button
          type="button"
          class="btn-secondary btn-toolbar"
          data-testid="btn-relatorios"
          [attr.aria-expanded]="relatoriosMenuAberto()"
          aria-haspopup="true"
          (click)="toggleRelatoriosMenu($event)"
        >Relatórios</button>
        @if (relatoriosMenuAberto()) {
          <div class="actions-menu-dropdown" role="menu">
            <button
              type="button"
              role="menuitem"
              data-testid="relatorio-option-adesoes"
              (click)="onRelatorioOption()"
            >
              Relatório de adesões
            </button>
            <button
              type="button"
              role="menuitem"
              data-testid="relatorio-option-campanhas"
              (click)="onRelatorioOption()"
            >
              Relatório de campanhas
            </button>
          </div>
        }
      </div>
      <button
        type="button"
        class="btn-primary btn-toolbar"
        data-testid="btn-criar-campanha"
        (click)="onCriarCampanha()"
      >Criar Campanha</button>
    </ng-container>
  </app-page-header>

  <app-filter-bar [fields]="filterFields()" (filtersChange)="onFiltersChange($event)" />

  <section aria-labelledby="campanhas-section-title">
    <h2 id="campanhas-section-title" class="page-section-title">Campanhas criadas</h2>

    @if (campanhas().length === 0) {
      <app-empty-state />
    } @else {
      <app-data-table ariaLabel="Campanhas criadas">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Status</th>
            <th scope="col">Início</th>
            <th scope="col">Fim</th>
            <th scope="col">Tipo</th>
            <th scope="col"><span class="visually-hidden">Ações</span></th>
          </tr>
        </thead>
        <tbody>
          @for (campanha of campanhasPaginadas(); track campanha.id) {
            <tr>
              <td>
                <a
                  class="table-link"
                  [routerLink]="['/campanhas', campanha.id]"
                  data-testid="campanha-link"
                >
                  {{ campanha.nome }}
                </a>
              </td>
              <td>
                <app-status-badge [status]="campanha.status" [label]="campanha.statusLabel" />
              </td>
              <td>{{ formatDate(campanha.dataInicio) }}</td>
              <td>{{ formatDate(campanha.dataFim) }}</td>
              <td>{{ campanha.tipo }}</td>
              <td class="actions-cell">
                <div
                  class="actions-menu"
                  [class.actions-menu--open]="menuAbertoId() === campanha.id"
                >
                  <button
                    type="button"
                    class="actions-menu-btn"
                    [attr.aria-expanded]="menuAbertoId() === campanha.id"
                    aria-haspopup="true"
                    [attr.aria-label]="'Ações para ' + campanha.nome"
                    data-testid="actions-menu-btn"
                    (click)="toggleMenu(campanha.id, $event)"
                  >
                    &#8942;
                  </button>
                  @if (menuAbertoId() === campanha.id) {
                    <div
                      class="actions-menu-dropdown actions-menu-dropdown--fixed"
                      role="menu"
                      [style.top.px]="menuPosition()?.top"
                      [style.right.px]="menuPosition()?.right"
                    >
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-visualizar"
                        (click)="onVisualizar(campanha, $event)"
                      >
                        Visualizar
                      </button>
                      @if (podeEditar(campanha)) {
                        <button
                          type="button"
                          role="menuitem"
                          data-testid="action-editar"
                          (click)="irParaEditar(campanha.id)"
                        >
                          Editar
                        </button>
                      }
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-clonar"
                        (click)="onClonar(campanha, $event)"
                      >
                        Clonar
                      </button>
                      <!-- Encerrar/Pausar/Cancelar removidos do menu (decisão do PO, 2026-08-10):
                        CampanhaVigenciaGuard.GarantirNaoVigenteEAtiva recusa qualquer PATCH/PUT/DELETE
                        fora de Rascunho ou Agendada; as três ações só fariam sentido saindo de
                        Ativa (Portal), que é justamente o status congelado, e não existe endpoint
                        dedicado para nenhuma delas hoje. Ver campanhas-list.component.ts:onAcaoFutura.
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-encerrar"
                        (click)="onAcaoFutura($event)"
                      >
                        Encerrar
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-pausar"
                        (click)="onAcaoFutura($event)"
                      >
                        Pausar
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-cancelar"
                        (click)="onAcaoFutura($event)"
                      >
                        Cancelar
                      </button>
                      -->
                      @if (podeExcluir(campanha)) {
                        <button
                          type="button"
                          role="menuitem"
                          data-testid="action-excluir"
                          (click)="onExcluirClick(campanha, $event)"
                        >
                          Excluir
                        </button>
                      }
                    </div>
                  }
                  @if (showExcluirId() === campanha.id) {
                    <app-alert-dialog
                      title="Excluir campanha"
                      message="Tem certeza que deseja excluir esta campanha?"
                      description="Essa ação removerá permanentemente a campanha selecionada."
                      cancelLabel="Cancelar"
                      confirmLabel="Excluir"
                      [showConfirmIcon]="false"
                      (confirm)="confirmarExclusao()"
                      (cancel)="cancelarExclusao()"
                    />
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize"
        [totalItems]="campanhas().length"
        (pageChange)="onPageChange($event)"
      />
    }
  </section>
</div>
